
























































import {Vue, Component} from 'vue-property-decorator'
import { mixins } from "vue-class-component";
import dataProxy from "@/services/data-proxy.service";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import moment from "moment";
import {formatDate, formatDateTime} from "@/utils/formatters";

@Component({})
export default class NaloziZaSluzbenoPutovanje extends mixins(ComponentBaseMixin) {

    odDatuma = moment().startOf('month').toDate();
    doDatuma = moment().endOf('month').toDate();
    osobaId: number = null;
    mestoTroska = '';

    nalozi = [];
    columns = [];
    options = {
        search: true,
        pagination: true,
        headerStyle: () => {return {css: {'font-size' : '10px'}}},
        onClickRow: row => this.onClickRow(row)
    };
    filterVisible = false;
    isBusy = false;
    isPrinting = false;
    pdfURL = '';
    brojNaloga = '';

    async created() {
        this.columns = [
            {field: 'datum', title: this.$i18n.t('datum'), formatter: formatDate, width: 60},
            {field: 'broj', title: this.$i18n.t('brojNaloga'), width: 90},
            {field: 'vozac', title: this.$i18n.t('vozac'), width: 120},
            {field: 'vozilo', title: this.$i18n.t('vozilo'), width: 120},
            {field: 'relacija', title: this.$i18n.t('mesto'), width: 100},
            {field: 'datumPolaska', title: this.$i18n.t('datumPolaska'), formatter: formatDateTime, width: 100},
            {field: 'datumZavrsetka', title: this.$i18n.t('datumZavrsetka'), formatter: formatDateTime, width: 100},
            {field: 'provedenoVreme', title: this.$i18n.t('brojSati'), width: 50},
            {field: 'brojDnevnica', title: this.$i18n.t('brojDnevnica'), width: 60},
            {field: 'iznosDnevnica', title: this.$i18n.t('iznosDnevnice'), width: 60},
            {field: 'ukupno', title: this.$i18n.t('ukupno'), width: 60},
            {field: 'predjenoKilometara', title: this.$i18n.t('predjenoKM'), width: 60},
        ];
        this.pretraziNaloge();
    }

    toggleFilter() {
        this.filterVisible = !this.filterVisible;
    }

    get postavljenFilter() {
        return !!this.osobaId || !!this.brojNaloga;
    }

    async pretraziNaloge() {
        try {
            this.isBusy = true;
            this.nalozi = await this.loadData(() => dataProxy.vratiNalogeZaSluzbenoPutovanje(this.odDatuma, this.doDatuma, this.brojNaloga, this.osobaId))();
        } finally {
            this.isBusy = false;
        }
    }

    async stampaj() {
        try {
            this.isPrinting = true;
            const link = await this.loadData(() => dataProxy.vratiStampuNalogaZaSluzbenoPutovanje(this.odDatuma, this.doDatuma, this.brojNaloga, this.osobaId))();
            this.pdfURL = `${link}?t=${new Date().getUTCMilliseconds()}`
        } finally {
            this.isPrinting = false;
        }
    }

    onClickRow(row) {
        this.$router.push('unos-putnog-naloga/' + row.id);
    }
}
